import React from 'react';
import { localize } from 'core/localization';
import { withTheme } from 'styled-components';
import { Text, Icon, Button } from 'components/common';
import { BUTTON, SIZES } from 'constants/components';
import DocumentContentParser, { DocumentContent } from './components/DocumentContentParser';
import {
  Container,
  HeaderContainer,
  TitleContainer,
  IconWrapper,
  TextWrapper,
  ButtonContainer,
  IframeContainer,
  Iframe
} from './Document.styled';

type DocumentProps = {
  content: string;
  theme: { [key: string]: any };
  inverted: boolean;
};

export const Document = ({ content, inverted }: DocumentProps) => {
  let data = DocumentContentParser.parse(content);

  return render(data, inverted);
};

export default withTheme(Document);

function render(data: DocumentContent, inverted: boolean) {
  return (
    <Container data-type={data.type} inverted={inverted}>
      {data.title && data.link && (
        <HeaderContainer>
          <TitleContainer>
            <IconWrapper>
              <Icon
                name="document"
                color={inverted ? 'coverBgOverlayTextColor' : 'textColor'}
                size={34}
                fontSize={9}
                text={data.type}
              />
            </IconWrapper>
            <TextWrapper>
              <Text appearance="h4">{data.title}</Text>
            </TextWrapper>
          </TitleContainer>
          <ButtonContainer>
            <Button
              textTransform="uppercase"
              size={SIZES.SMALL}
              layout={BUTTON.LAYOUT.SECONDARY}
              link={data.link}
              inverted={inverted}
            >
              {localize('[download]')} ({data.size})
            </Button>
          </ButtonContainer>
        </HeaderContainer>
      )}
      {data.iframe.src && (
        <IframeContainer>
          <Iframe width={data.iframe.width} height={data.iframe.height} src={data.iframe.src} />
        </IframeContainer>
      )}
    </Container>
  );
}
